// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K5ZR","option":"styles_option__2xZgd","active":"styles_active__1vNi0"};